import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "The Value-Driven Leader",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">The Value-Driven Leader</h2>
                                    <p>Cultivating Authenticity and Impact</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/leader.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>In a professional world craving genuine connection, leadership must transcend mere authority. This course, "The Value-Driven Leader," empowers you to cultivate an authentic leadership style that resonates with your team, fosters collaboration, and drives meaningful impact. Learn to align your personal values with your professional actions, leaving a lasting, positive legacy.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why I Created This Course</h5>
                                                    <p>I have witnessed countless leaders struggle to connect authentically with their teams, resulting in disengagement and missed opportunities. This course addresses that gap, providing a practical framework for cultivating value-driven leadership that inspires, empowers, and delivers tangible results.</p>

                                                    <h5 className="title mt-3">Course Curriculum</h5>
                                                    <ul className="liststyle">
                                                        <li>Module 1: The Foundations of Value-Driven Leadership: Exploring core principles and aligning personal values with leadership practices.</li>
                                                        <li>Module 2: Building Trust & Fostering Collaboration: Creating a culture of openness, transparency, and shared purpose.</li>
                                                        <li>Module 3: Driving Impactful Change Through Authenticity: Leading with integrity and inspiring positive transformation.</li>
                                                        <li>Module 4: Leaving a Lasting Legacy: Cultivating Sustainable Leadership: Developing strategies for long-term impact and team empowerment.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this course, you will learn how to:</h5>
                                                    <ul className="liststyle">
                                                        <li>Align your personal values with your leadership style.</li>
                                                        <li>Build trust and foster collaborative team environments.</li>
                                                        <li>Drive impactful change through authentic leadership.</li>
                                                        <li>Create a lasting, positive legacy through your actions.</li>
                                                        <li>Empower and inspire others to achieve their full potential.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this course, you will leave with:</p>
                                                    <ul className="liststyle">
                                                        <li>A personalised value-driven leadership framework.</li>
                                                        <li>Practical strategies for building trust and fostering collaboration.</li>
                                                        <li>The ability to lead with authenticity and drive meaningful change.</li>
                                                        <li>A clear understanding of how to create a lasting, positive legacy.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the course structured?</h5>
                                                    <p>This ten-week transformative Program features live interactive workshops, practical case studies, and personalised coaching. You will gain access to a supportive community of like-minded leaders and exclusive resources.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this course suitable for leaders at all levels?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the principles of value-driven leadership are applicable to emerging and experienced leaders alike.</p>

                                                        <li>Will this course help me improve team engagement and collaboration?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. We focus extensively on building trust and fostering collaborative team environments.</p>

                                                        <li>Are there practical exercises to implement the learned strategies?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the course includes practical exercises and case studies to reinforce learning and facilitate real-world application.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £499</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("The Value-Driven Leader", "https://mainstack.store/coachdoi/YcgybYICEFfo")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;